import { RowNode } from 'ag-grid-community';
import { FieldType, FilterableField } from 'components/organisms/tasks/fields';
import { defaultDueDateOrder, defaultStartDateOrder } from './key-creator';

export const getDefaultGroupSortComparator = (
  lookupByFieldName: Record<string, FilterableField>,
): ((nodeA: RowNode, nodeB: RowNode) => number) => {
  return (nodeA, nodeB) => {
    if (!nodeA.group || nodeA.field == null) {
      return -1;
    }

    const valueA: string = nodeA.key;
    const valueB: string = nodeB.key;

    const field = lookupByFieldName[nodeA.field];

    switch (field?.type) {
      case FieldType.SingleSelect:
        if (!valueA) {
          return 1;
        }

        if (!valueB) {
          return 0;
        }

        return (
          field.metaData.options.findIndex(
            (opt) => opt.value.toString() === valueA,
          ) -
          field.metaData.options.findIndex(
            (opt) => opt.value.toString() === valueB,
          )
        );
      case FieldType.Date:
        switch (field.fieldName) {
          case 'startDate':
            return (
              defaultStartDateOrder.indexOf(valueA) -
              defaultStartDateOrder.indexOf(valueB)
            );
          case 'dueDate':
            return (
              defaultDueDateOrder.indexOf(valueA) -
              defaultDueDateOrder.indexOf(valueB)
            );
          default:
            return 0;
        }
      default:
        return valueA === valueB ? 0 : valueA > valueB ? 1 : -1;
    }
  };
};
